export default {
    billboardLabelsSettings: {
        printer: null,
        workspace: null
    },
    standardLabelsSettings: {
        printer: null,
        workspace: null
    },
    revisoryLabelsSettings: {
        printer: null,
        workspace: null
    },
    workspaces: []
}